document.querySelector('#ouvre-candidats-mobile').addEventListener("click", function(e){
  e.preventDefault();
    document.querySelector('.menu-navigation-mobile-candidats').classList.toggle('actif')
});

document.querySelector('#ouvre-themes-mobile').addEventListener("click", function(e){
  e.preventDefault();
    document.querySelector('.menu-navigation-mobile-themes').classList.toggle('actif')
});



// Navigation mobile
document.querySelector('.burger-mobile').addEventListener("click", function(){
  var burger = document.querySelector('.burger-mobile')
  burger.classList.toggle('actif');

  if (burger.classList.contains('actif')) {
      document.querySelector('.zone-menu-navigation-mobile').classList.add('actif')
      document.querySelector('body').style.position = 'fixed'
  } else {
    document.querySelector('.zone-menu-navigation-mobile').classList.remove('actif')
    document.querySelector('body').style.position = 'relative'

    // Fermer les sous menus
    setTimeout(function () {
      document.querySelector('.menu-navigation-mobile-themes').classList.remove('actif')
      document.querySelector('.menu-navigation-mobile-candidats').classList.remove('actif')
    }, 500);



  };

});


let retour = document.querySelectorAll('.bt-retour-menu')
for (let i = 0; i < retour.length; i++) {
 
  retour[i].addEventListener("click", function(e) {
    let menu =  retour[i].closest('.menu-navigation-mobile');
    menu.classList.remove('actif')
  });
}